import { Card, CardBody, Skeleton, Tooltip } from "@heroui/react";
import { ThemedText } from "@/components/ui";
import { LuInfo } from "react-icons/lu";

const colorMap = {
    primary:
        "bg-primary-100 text-primary-600 dark:bg-primary-900/30 dark:text-primary-400",
    success:
        "bg-success-100 text-success-600 dark:bg-success-900/30 dark:text-success-400",
    warning:
        "bg-warning-100 text-warning-600 dark:bg-warning-900/30 dark:text-warning-400",
    danger: "bg-danger-100 text-danger-600 dark:bg-danger-900/30 dark:text-danger-400",
};

const StatCard = ({ icon, label, value, formatFn, isLoading, color = "primary", tooltip }) => {
    return (
        <Card className="border border-default-200" shadow="none">
            <CardBody className="flex flex-row items-center gap-4 p-4">
                <div
                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${colorMap[color]}`}
                >
                    {icon}
                </div>
                <div className="flex flex-col gap-0.5 overflow-hidden">
                    <div className="flex items-center gap-1">
                        <ThemedText variant="secondary" size="xs">
                            {label}
                        </ThemedText>
                        {tooltip && (
                            <Tooltip content={tooltip} placement="top">
                                <span className="cursor-help text-default-400">
                                    <LuInfo size={10} />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                    {isLoading ? (
                        <Skeleton className="h-6 w-28 rounded-md" />
                    ) : (
                        <ThemedText
                            size="lg"
                            className="truncate font-bold"
                        >
                            {formatFn ? formatFn(value) : value}
                        </ThemedText>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default StatCard;
